import styled__default, { withTheme as withTheme$1, ThemeProvider as ThemeProvider$1, css as css$1 } from 'styled-components';

var styled = styled__default,
  withTheme = withTheme$1,
  ThemeProvider = ThemeProvider$1,
  css = css$1;

export default styled;
export { ThemeProvider, css, withTheme };
